import { Controller } from "@hotwired/stimulus";
import PDFObject from "pdfobject";

/*

Use this controller to embed PDFs in the page, using  a DaisyUI modal.

It will look over any data-controller="pdf-embed" attribute present in a link and
will open the PDF that is in the href attribute of that link in a modal.

On mobile devices, the PDF will be opened in a new tab. We do not support embedding PDF
on mobile devices.

Sample usage:
  1. Plain HTML:
     <a href="link to your PDF file" data-controller="pdf-embed" class="text-gray-700 font-bold ps-5">
  2. Rails powered by Stejar:
      <%= link_to rails_blob_path(@asset.file, disposition: 'inline'), target: :_blank,
              data: { controller: @asset.pdf? ? 'pdf-embed' : '' },
              class: "text-sky-600 hover:text-sky-800  w-full hover:underline flex items-top",
              title: @asset.pdf? ? 'Click pentru a vizualiza' : '' do %>
        <div class="h-5 w-5 me-3">
          <%= image_tag asset_path(@asset.file_icon) %>
        </div>
        <div class="flex-1">
          <%= @asset.t(:title) %>
        </div>
      <% end %>
   <% end %>
*/

export default class extends Controller {
  initialize() {
    this.container = null;
  }

  connect() {
    this.element.addEventListener('click', this.loadPDF.bind(this));
  }

  loadPDF(event) {
    event.preventDefault();
    this.insertContainer();

    const options = {
      pdfOpenParams: {
        view: 'FitH',
        width: '100%',
        height: '100%',
        scrollbars: 'no'
      }
    };

    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    const pdfUrl = this.element.getAttribute('href');

    // Open in a new widnow on mobile devices
    if (isMobile) {
      window.open(pdfUrl, '_blank');

      return;
    }

    const isPDFEmbedded = PDFObject.embed(pdfUrl, document.getElementById("pdf-container"), options);

    if (!isPDFEmbedded) {
      window.open(pdfUrl, '_blank');
    } else {
      this.container.showModal();
    }
  }

  disconnect() {
    this.element.removeEventListener('click', this.loadPDF.bind(this));
  }

  insertContainer() {
    if (this.container != null) {
      return this.container;
    }

    const content = `
      <dialog class="du-modal flex items-center justify-center bg-neutral/25" id="pdf-modal" data-behavior="cancel">
        <div class="du-modal-box w-full max-w-5xl h-[85vh] md:h-[90vh] p-4 rounded-lg shadow-lg flex flex-col">
          <form method="dialog">
            <button type="button" class="du-btn du-btn-sm du-btn-circle absolute -right-4 -top-4 me-5 mt-5 text-lg" data-behavior="cancel" autofocus>
              <i class="icon-x text-2xl"></i>
            </button>
          </form>
          <div id="pdf-container" class="w-full h-full md:h-[85vh] flex justify-center items-center"></div>
        </div>
      </dialog>
    `;

    document.body.insertAdjacentHTML('beforeend', content);
    document.activeElement.blur();

    this.container = document.getElementById("pdf-modal");

    document.querySelectorAll("[data-behavior='cancel']").forEach((cancelButton) => {
      cancelButton.addEventListener("click", () => {
        this.container.close();
      });
    });
  }
}
